// src/services/api.js
// ─────────────────────────────────────────────────────────────────────────────
// MUDANÇA: interceptor de resposta 401 — só exibe "sessão expirada" quando
// havia um usuário autenticado no momento do erro (sessão expirou de verdade).
// Se currentUser já era null (logout voluntário ou sem sessão), silencia a
// mensagem e apenas redireciona para o login se necessário.
// ─────────────────────────────────────────────────────────────────────────────

import axios from "axios";
import router from "@/router";
import { useUserStore } from "@/stores/useUserStore";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor de requisição — adiciona token (sem alteração)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("userToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Interceptor de resposta — trata 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.error("API Error: 401 Unauthorized.");

      const userStore = useUserStore();

      // ✅ MUDANÇA: só exibe a mensagem de sessão expirada se havia um usuário
      // autenticado no momento do erro. Se currentUser já era null, o 401 veio
      // de um logout voluntário ou de uma requisição sem sessão — sem mensagem.
      const wasAuthenticated = !!userStore.currentUser;

      userStore.currentUser = null;
      localStorage.removeItem("userToken");

      // ✅ MUDANÇA: só redireciona para o login quando havia uma sessão que
      // expirou. Um visitante anônimo que recebe 401 (ex.: nota pública que
      // consulta um endpoint autenticado) NÃO deve ser mandado ao login — as
      // rotas protegidas já são cobertas pelo guard do router.
      if (wasAuthenticated) {
        userStore.error =
          "Sua sessão expirou ou é inválida. Por favor, faça login novamente.";

        if (router.currentRoute.value.name !== "LoginView") {
          router.push({ name: "LoginView" });
        }
      }
    }

    return Promise.reject(error);
  },
);

export default api;
